// @ts-expect-error no types from package
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import { stringify } from 'hub-http/helpers/params';
import { requestActions, updateAction } from './utils';
import { simpleAction } from './utils';
import { finishVerifying, finishRequestingCode, showTokenExpiredAlert, showInvalidCodeAlert, showInvalidTokenAlert, showSmsRateLimitAlert, showGenericTwoFactorErrorAlert, showBlockedLoginMethodAlert, showUserDeactivatedAlert, toggleRememberDeviceModal, setLoginWithHSPrompt, setToken, showRestrictedIpAddressAlert } from '../actions';
import TwoFactorAuthActionTypes from './TwoFactorAuthActionTypes';
import SsoRequiredAuthStatuses from '../constants/SsoRequiredAuthStatuses';
import TwoFactorAuthStatuses from '../constants/TwoFactorAuthStatuses';
import ConfirmToLoginStatuses from '../constants/ConfirmToLoginAuthStatuses';
import TwoFactorAuthHSAppStatuses from '../constants/TwoFactorAuthHSAppStatuses';
import TwoFactorLoginDao from '../data/TwoFactorLoginDao';
const twoFactorDao = new TwoFactorLoginDao();
const appCookieLoginWithHubspotApp = new HubSpotOnlyAppCookieLogin({
  loginRequest: twoFactorDao.loginWithHubspotApp.bind(twoFactorDao)
});
const ResetPage = simpleAction(TwoFactorAuthActionTypes.CLICKED_BACK_BUTTON);
export const resetPage = () => dispatch => {
  dispatch(ResetPage());
};
export const handle2faLoginSuccess = (responses, history, loginRedirectUrl) => dispatch => {
  const response = responses[0];
  if (response.status === SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED) {
    const {
      hubId,
      requiredBy
    } = response;
    dispatch(finishVerifying());
    dispatch(finishRequestingCode());
    const nextPath = `/sso?${stringify({
      loginPortalId: hubId,
      loginRedirectUrl,
      required: true,
      requiredBy
    })}`;
    return history.push(nextPath);
  }
  if (response.status === ConfirmToLoginStatuses.SUSPICIOUS_USER_MUST_CONFIRM) {
    const {
      token
    } = response;
    if (token) {
      dispatch(setToken({
        token
      }));
    }
    dispatch(finishVerifying());
    dispatch(finishRequestingCode());
    const nextPath = `/confirm-to-login?${stringify({
      loginRedirectUrl: response.loginRedirectUrl,
      loginPortalId: response.loginPortalId
    })}`;
    return history.push(nextPath);
  }
  return appCookieLoginWithHubspotApp.redirectOnLoginSuccess(responses);
};
export const handle2faLoginFailure = (resp, history) => dispatch => {
  if (resp.status === 404) {
    dispatch(showGenericTwoFactorErrorAlert());
  } else {
    const responseJSON = resp && resp.responseText && JSON.parse(resp.responseText);
    if (responseJSON) {
      const {
        status,
        errorTokens
      } = responseJSON;
      if (status === TwoFactorAuthStatuses.INVALID_CODE) {
        dispatch(showInvalidCodeAlert());
      } else if (status === TwoFactorAuthStatuses.EXPIRED_TWO_FACTOR_TOKEN) {
        dispatch(showTokenExpiredAlert());
        history.push('/');
      } else if (status === TwoFactorAuthStatuses.INVALID_TWO_FACTOR_TOKEN) {
        dispatch(showInvalidTokenAlert());
        history.push('/');
      } else if (status === TwoFactorAuthStatuses.SMS_RATE_LIMIT_HIT) {
        dispatch(showSmsRateLimitAlert());
      } else if (status === TwoFactorAuthStatuses.BLOCKED_LOGIN_METHOD) {
        dispatch(showBlockedLoginMethodAlert());
      } else if (status === TwoFactorAuthStatuses.DEACTIVATED_USER) {
        var _errorTokens$vettingU;
        if (errorTokens !== null && errorTokens !== void 0 && (_errorTokens$vettingU = errorTokens.vettingUrl) !== null && _errorTokens$vettingU !== void 0 && _errorTokens$vettingU[0]) {
          var _errorTokens$vettingU2;
          const vettingUrl = errorTokens === null || errorTokens === void 0 || (_errorTokens$vettingU2 = errorTokens.vettingUrl) === null || _errorTokens$vettingU2 === void 0 ? void 0 : _errorTokens$vettingU2[0];
          const searchString = `?${stringify({
            vettingUrl
          })}`;
          history.push(`/vetting/${searchString}`);
        } else {
          dispatch(showUserDeactivatedAlert());
        }
      } else if (status === TwoFactorAuthStatuses.RESTRICTED_IP_ADDRESS) {
        dispatch(showRestrictedIpAddressAlert());
      } else {
        dispatch(showGenericTwoFactorErrorAlert());
      }
    } else {
      dispatch(showGenericTwoFactorErrorAlert());
    }
  }
  dispatch(finishVerifying());
  dispatch(finishRequestingCode());
};
const fetchHubspotAppStatus = requestActions(TwoFactorAuthActionTypes.FETCH_HUBSPOT_APP_STATUS);
export const updateHubspotAppStatus = updateAction(TwoFactorAuthActionTypes.UPDATE_HUBSPOT_APP_STATUS);
export const requestHubspotAppStatus = (token, fetchWithInterval, setModalTimer, history) => dispatch => {
  dispatch(fetchHubspotAppStatus.request());
  return twoFactorDao.fetchHubspotAppStatus(token).then(data => {
    if (data !== TwoFactorAuthHSAppStatuses.PENDING) {
      dispatch(updateHubspotAppStatus(data));
      clearInterval(fetchWithInterval);
      clearTimeout(setModalTimer);
      if (data === TwoFactorAuthHSAppStatuses.APPROVED) {
        dispatch(setLoginWithHSPrompt());
        dispatch(toggleRememberDeviceModal());
      }
    }
  }).catch(error => {
    clearInterval(fetchWithInterval);
    clearTimeout(setModalTimer);
    handle2faLoginFailure(error, history)(dispatch);
  });
};